import {Image as KonvaImage} from 'react-konva';
import {Image} from "@/images/Image.ts";
import {srcUrl} from "@/api/ImageApi.ts";
import Konva from "konva";
import {ReactElement} from "react";
import {useCachedImage} from "@/images/ImageCache.ts";


export default function CanvasImage(
    {image, visible = true, ...rest}: { image: Image, visible?: boolean } & Konva.NodeConfig
): ReactElement<Konva.Image> | null {
    const loadedImage = useCachedImage(srcUrl(image));
    if (!visible) return null;
    return <KonvaImage image={loadedImage} {...rest} />;
}
